import {
  ChipSelectOption,
  CalendarEventInterface,
} from '@lyceo/shared/plan/util-models';

export const estimatedDurationOptions: ChipSelectOption[] = [
  {
    label: '10 min',
    value: '00:10:00',
  },
  {
    label: '15 min',
    value: '00:15:00',
  },
  {
    label: '30 min',
    value: '00:30:00',
  },
  {
    label: '45 min',
    value: '00:45:00',
  },
  {
    label: '60 min',
    value: '01:00:00',
  },
  {
    label: '90 min',
    value: '01:30:00',
  },
];

export const subtaskColor: CalendarEventInterface['color'] = {
  color: '--trix-color-plan-subtask-dark',
  contrast: '--trix-color-plan-contrast',
};

export const defaultColor: CalendarEventInterface['color'] = {
  color: '--trix-color-plan-default-dark',
  contrast: '--trix-color-plan-contrast',
};
